import { createFileRoute } from '@tanstack/react-router';
import FindSlotsPage from '@/scheduling/pages/FindSlotsPage';

export const Route = createFileRoute('/_authenticated/find-slots')({
  component: FindSlotsPage,
});
